import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-wa-message',
	standalone: true,
	imports: [MatButtonModule, MatIconModule],
	templateUrl: './wa-message.component.html',
	styleUrl: './wa-message.component.scss',
})
export class WaMessageComponent {
	@Input() wa!: any;
	@Input() waLink: any;
	waBaseUrl = environment.waBucketUrl;

	getImageUrl(): string | null {
		return `${this.waBaseUrl}/${this.wa?.image?.gcp_media_path}`;
	}
	openImageInNewWindow() {
		const imageUrl = this.getImageUrl();
		if (imageUrl) {
			window.open(imageUrl, '_blank');
		}
	}
}
